import styled, { css } from "styled-components";

import { alignItemsCenter, flexColumn, rem } from "@styles/Utilities.styled";

import { StyledSurgicalHistoryCard } from "../SurgicalHistoryCard/SurgicalHistoryCard.styled";


export const medicalHistoryColors = css`
  &.red {
    color: var(--crimson-11);
    background-color: var(--crimson-3);
  }

  &.orange {
    color: var(--orange-11);
    background-color: var(--orange-3);
  }

  &.green {
    color: var(--green-11);
    background-color: var(--green-3);
  }

  &.blue {
    color: var(--blue-11);
    background-color: var(--blue-3);
  }
`;

export const StyledMedicalHistoryCard = styled(StyledSurgicalHistoryCard)`
  .timeline-item {
    align-items: start;
    margin-block: auto;
  }

  .wrapper {
    ${flexColumn}

    span {
      line-height: 1;
    }
  }

  .tags {
    ${alignItemsCenter}
    gap: 0.5em;
    margin-top: 0.35rem;
    // outline: 1px solid red;

    span {
      font-size: ${rem(11)};
      font-weight: 500;
      padding: 0.2em 1em;
      border-radius: 100vmax;
      text-transform: capitalize;

      ${medicalHistoryColors}
    }
  }

  .card-footer {
    margin-top: unset;
  }
`;
